module.exports = __webpack_public_path__ + "img/28.2f0f44a0.svg";